import { qz } from "../client";
import { createNamespaceMutation } from "../internal/createNamespaceMutation";
import { addActiveFilePath, fileStore, removeActiveFilePath } from "./state";
import {
  type FileRemoveInput,
  type FileStartListeningInput,
  type FileStopListeningInput,
  type FileWriteInput,
} from "./types";

export const fileWriteMutationOptions = createNamespaceMutation({
  key: ["qz.file.write"],
  run: async ({ params, path }: FileWriteInput) => {
    await qz.file.write(path, params);
  },
  store: fileStore,
});

export const fileRemoveMutationOptions = createNamespaceMutation({
  key: ["qz.file.remove"],
  run: async ({ params, path }: FileRemoveInput) => {
    await qz.file.remove(path, params);
  },
  store: fileStore,
});

export const fileStartListeningMutationOptions = createNamespaceMutation({
  key: ["qz.file.startListening"],
  run: async ({ params, path }: FileStartListeningInput) => {
    await qz.file.startListening(path, params);
    addActiveFilePath(path);
  },
  store: fileStore,
});

export const fileStopListeningMutationOptions = createNamespaceMutation({
  key: ["qz.file.stopListening"],
  run: async ({ params, path }: FileStopListeningInput = {}) => {
    await qz.file.stopListening(path, params);
    removeActiveFilePath(path);
  },
  store: fileStore,
});
